// 品牌配置文件 - 可自定义替换logo、slogan和业务信息
export const brandConfig = {
  // 主品牌信息
  brand: {
    name: '云帐天下',
    slogan: '智能财务管理系统',
    description: '云帐天下官网 - 物流行业智能财务系统',
    logo: {
      // 主logo图片路径
      image: '/logo.png'
    }
  },

  // 集团其他业务配置
  groupBusinesses: [
    {
      id: 'logistics-service',
      name: '物流人工客服',
      url: '#',
      description: '专业的物流客服解决方案'
    },
    {
      id: 'logistics-finance',
      name: '物流人工财务',
      url: '#',
      description: '物流行业财务管理服务'
    },
    {
      id: 'smart-assistant',
      name: '智运小蜜',
      url: '#',
      description: '辅助物流客服工作的智能客户端'
    },
    {
      id: 'shengxinhe',
      name: '盛信和',
      url: '#',
      description: '花茶代加工业务'
    },
    {
      id: 'production-erp',
      name: '生产进销存系统',
      url: '#',
      description: '生产企业进销存管理系统'
    },
    {
      id: 'bee-erp',
      name: '蜜蜂ERP',
      url: '#',
      description: '涵盖CRM的企业资源规划系统'
    }
  ],

  // 版权信息
  copyright: {
    year: '2024',
    company: '云帐天下集团',
    text: '保留所有权利.'
  },

  // 主题色彩配置
  theme: {
    primary: {
      50: '#eff6ff',
      500: '#3b82f6',
      600: '#2563eb',
      700: '#1d4ed8'
    },
    secondary: {
      500: '#10b981',
      600: '#059669'
    },
    gray: {
      50: '#f9fafb',
      500: '#6b7280',
      700: '#374151',
      800: '#1f2937'
    }
  }
};

// 导出默认配置
export default brandConfig;